'use client';

const defaultProps = {
  variant: "default",
  a11yImportance: "polite"
};
export {
  defaultProps
};
